import { useEffect } from "react";

export function useDynamicManifest(name, shortName, iconSet = "eventi") {
  useEffect(() => {
    const link = document.querySelector('link[rel="manifest"]');
    const touchIcon = document.querySelector('link[rel="apple-touch-icon"]');
    const titleMeta = document.querySelector('meta[name="apple-mobile-web-app-title"]');
    if (!link) return;
    const original = link.getAttribute("href");
    const originalDocTitle = document.title;
    document.title = name;
    const originalTouch = touchIcon?.getAttribute("href");
    const originalTitle = titleMeta?.getAttribute("content");
    const iconHref = iconSet === "tavoli" ? "/icon-tavoli-192.png" : "/icon-192.png";
    const url = `/api/pwa-manifest?path=${encodeURIComponent(window.location.pathname)}&name=${encodeURIComponent(name)}&icon=${iconSet}`;
    link.setAttribute("href", url);
    if (touchIcon) touchIcon.setAttribute("href", iconHref);
    if (titleMeta) titleMeta.setAttribute("content", shortName);
    return () => {
      link.setAttribute("href", original);
      document.title = originalDocTitle;
      if (touchIcon && originalTouch) touchIcon.setAttribute("href", originalTouch);
      if (titleMeta && originalTitle) titleMeta.setAttribute("content", originalTitle);
    };
  }, [name, shortName, iconSet]);
}
